/**
 * AgentMonitorPage
 *
 * AIFY Agent 모니터링 포털의 진입 페이지.
 * 탭 (에이전트 관리 / 에이전트 변환) 을 호스트한다.
 */

import { useRef, useState } from "react";
import { Box, Tab, Tabs, Typography } from "@mui/material";
import SmartToyIcon from "@mui/icons-material/SmartToy";
import BuildIcon from "@mui/icons-material/Build";

import { AgentsTab } from "./components/AgentsTab";
import { SkillsTab } from "./components/SkillsTab";

type TabValue = "agents" | "skills";

export default function AgentMonitorPage() {
  const [activeTab, setActiveTab] = useState<TabValue>("agents");
  const contentRef = useRef<HTMLDivElement | null>(null);

  return (
    <Box sx={{ width: "100%", height: "100%", display: "flex", flexDirection: "column" }}>
      <Box sx={{ px: 3, pt: 2 }}>
        <Typography variant="h5" fontWeight={600}>
          에이전트 모니터링
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          AIFY Agent 테넌트 상태 · 에이전트 변환
        </Typography>
      </Box>

      <Box sx={{ borderBottom: 1, borderColor: "divider", px: 3 }}>
        <Tabs
          value={activeTab}
          onChange={(_e, v: TabValue) => setActiveTab(v)}
          aria-label="agent monitor tabs"
        >
          <Tab icon={<SmartToyIcon fontSize="small" />} iconPosition="start" value="agents" label="에이전트 관리" />
          <Tab icon={<BuildIcon fontSize="small" />} iconPosition="start" value="skills" label="에이전트 변환" />
        </Tabs>
      </Box>

      <Box ref={contentRef} sx={{ flex: 1, overflow: "auto", p: 3 }}>
        {activeTab === "agents" && <AgentsTab />}
        {activeTab === "skills" && <SkillsTab />}
      </Box>
    </Box>
  );
}
